import { Box, Heading, Link, Text, VStack } from "@chakra-ui/react";
import * as React from "react";
import type { Lang } from "../lib/lang";
import Footer from "./Footer";
import Header from "./Header";

/** A block of content within a section. */
export type Block =
  | { type: "p"; text: string }
  | { type: "p-bold"; text: string }
  | { type: "link"; href: string; text: string };

export type Section = { heading: string; blocks: Block[] };

/** Same page, keyed by language. */
export type PageContent = Record<Lang, Section[]>;

function renderBlock(block: Block, key: number, prev?: Block) {
  switch (block.type) {
    case "p":
      return (
        <Text key={key} marginTop="5" textAlign="justify">
          {block.text}
        </Text>
      );
    case "p-bold":
      return (
        <Text
          key={key}
          marginTop={prev && prev.type === "p-bold" ? "2" : "5"}
          textAlign="justify"
          fontWeight="bold"
        >
          {block.text}
        </Text>
      );
    case "link":
      return (
        <Box key={key} my={3}>
          <Link href={block.href} isExternal fontWeight="bold" color="#D03230">
            {block.text}
          </Link>
        </Box>
      );
  }
}

const PolicyPage = ({ sections }: { sections: Section[] }) => (
  <VStack spacing={12} align="stretch" width="100%">
    <Header />
    <Box
      fontSize={{ base: "lg", md: "xl" }}
      px={{ base: 4, md: 12 }}
      py={{ base: 2, md: 6 }}
      width="100%"
    >
      {sections.map((section, i) => (
        <Box width="100%" my={i === 0 ? 0 : 5} key={i}>
          <Heading size={{ base: "lg", md: "xl" }}>{section.heading}</Heading>
          {section.blocks.map((block, j) =>
            renderBlock(block, j, section.blocks[j - 1])
          )}
        </Box>
      ))}
    </Box>
    <Footer />
  </VStack>
);

export default PolicyPage;
